import React, { useState } from "react";
import { Smartphone } from "lucide-react";

// Responsive widths the backend can render on the fly via /api/files/...?w=<n>
const RESP_WIDTHS = [160, 240, 320, 480, 640, 768, 1024, 1200];

function buildSrcSet(src) {
  if (!src || !src.includes("/api/files/")) return undefined;
  const sep = src.includes("?") ? "&" : "?";
  return RESP_WIDTHS.map((w) => `${src}${sep}w=${w} ${w}w`).join(", ");
}

/**
 * Premium liquid-glass placeholder used until real Smarti visuals are uploaded.
 * Renders the real <img> (with responsive srcset for backend-served files) when a
 * src is provided, otherwise a branded glass block.
 */
export default function ProductImage({ src, alt = "", label = "", className = "", glyph: Glyph = Smartphone, priority = false, sizes, width = 1000, height = 1000, ...rest }) {
  const [err, setErr] = useState(false);
  if (src && !err) {
    const srcSet = buildSrcSet(src);
    const effectiveSizes = srcSet
      ? (sizes || (priority ? "(max-width: 768px) 100vw, 720px" : "(max-width: 640px) 50vw, 340px"))
      : undefined;
    return <img src={src} srcSet={srcSet} sizes={effectiveSizes} alt={alt} width={width} height={height} loading={priority ? "eager" : "lazy"} decoding="async"
      fetchPriority={priority ? "high" : undefined} onError={() => setErr(true)} className={className} {...rest} />;
  }
  return (
    <div className={`${className} relative grid place-items-center overflow-hidden bg-[#F5F7FB]`} role="img" aria-label={alt || label} {...rest}>
      <div className="absolute -top-8 -right-8 h-40 w-40 rounded-full bg-gradient-to-br from-[#0073FF]/25 via-[#5AC8FA]/15 to-transparent blur-2xl" />
      <div className="absolute -bottom-10 -left-8 h-36 w-36 rounded-full bg-gradient-to-br from-[#5AC8FA]/15 to-transparent blur-2xl" />
      <div className="absolute inset-0 dot-grid opacity-70" />
      <Glyph className="relative h-1/3 w-1/3 text-[#0A0A0F]/12" strokeWidth={1} />
      {label && (
        <span className="absolute bottom-2 left-0 right-0 truncate px-3 text-center text-[10px] font-medium tracking-wide text-[#86868B]">
          {label}
        </span>
      )}
    </div>
  );
}
